if (!customElements.get('vehicle-finder')) {
  customElements.define('vehicle-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.initializeDisclosure();
      this.initialize().catch(() => {
        this.querySelector('[data-status]').textContent = this.querySelector('[data-status]').dataset.error;
      });
    }
    async initialize() {
      const response = await fetch(this.dataset.source);
      if (!response.ok) throw new Error('Vehicle data unavailable');
      this.vehicles = await response.json();
      this.year = this.querySelector('[data-year]');
      this.make = this.querySelector('[data-make]');
      this.model = this.querySelector('[data-model]');
      this.submodel = this.querySelector('[data-submodel]');
      this.drivetrain = this.querySelector('[data-drivetrain]');
      this.submit = this.querySelector('[data-submit]');
      this.fill(this.year, [...new Set(this.vehicles.map(v => String(v.year)))].sort((a, b) => Number(b) - Number(a)));
      this.year.addEventListener('change', () => this.refreshMakes());
      this.make.addEventListener('change', () => this.refreshModels());
      this.model.addEventListener('change', () => this.refreshSubmodels());
      this.submodel.addEventListener('change', () => this.refreshDrivetrains());
      this.drivetrain.addEventListener('change', () => {
        this.submit.disabled = !this.selection();
        this.updateDisclosureSummary();
      });
      this.querySelector('[data-vehicle-form]').addEventListener('submit', event => {
        event.preventDefault();
        const selected = this.selection();
        if (!selected) return;
        try { localStorage.setItem('baja-vehicle', JSON.stringify({tag: selected.vehicle.tag, submodel: selected.submodel.slug, drivetrain: selected.drivetrain})); } catch (_) {}
        location.assign(this.resultsURL(selected).href);
      });
      this.querySelector('[data-clear]').addEventListener('click', () => {
        try { localStorage.removeItem('baja-vehicle'); } catch (_) {}
        this.year.value = '';
        this.refreshMakes();
        this.year.focus();
      });
      const url = new URL(location.href);
      const query = url.searchParams.get('q');
      const match = query?.match(/^\(?tag:(fit-[a-z0-9-]+)(?: OR tag:fit-group-[a-z0-9-]+)*\)?(?: AND -tag:fit-exclude-([a-z0-9-]+))?$/);
      let saved;
      if (match) {
        const drive = match[1].match(/-(2wd|4wd)$/)?.[1];
        saved = {tag: drive ? match[1].slice(0, -4) : match[1], submodel: match[2] || 'all', drivetrain: drive};
      }
      else if (!query) {
        try {
          const stored = localStorage.getItem('baja-vehicle');
          saved = stored?.startsWith('fit-') ? {tag: stored, submodel: 'all'} : JSON.parse(stored);
        } catch (_) {}
      }
      const vehicle = this.vehicles.find(v => v.tag === saved?.tag);
      if (vehicle) {
        this.year.value = String(vehicle.year);
        this.refreshMakes(); this.make.value = vehicle.make;
        this.refreshModels(); this.model.value = vehicle.model;
        this.refreshSubmodels(); this.submodel.value = saved.submodel;
        this.refreshDrivetrains(); this.drivetrain.value = saved.drivetrain || '';
        this.submit.disabled = !this.selection();
      }
      const selected = this.selection();
      this.updateDisclosureSummary();
      document.querySelectorAll('[data-vehicle-title]').forEach(el => {
        if (selected && match) el.textContent = `${selected.vehicle.year} ${selected.vehicle.make} ${selected.vehicle.model}${selected.submodel.slug === 'all' ? '' : ' — ' + selected.submodel.name} — ${selected.drivetrain.toUpperCase()}`;
      });
    }
    initializeDisclosure() {
      this.disclosure = this.querySelector('[data-vehicle-disclosure]');
      if (!this.disclosure || !window.matchMedia) return;
      this.mobileMedia = window.matchMedia('(max-width: 749px)');
      this.mobileDisclosureOpen = false;
      this.syncDisclosure = () => {
        this.disclosure.open = this.mobileMedia.matches ? this.mobileDisclosureOpen : true;
      };
      this.disclosure.addEventListener('toggle', () => {
        if (this.mobileMedia.matches) this.mobileDisclosureOpen = this.disclosure.open;
        else if (!this.disclosure.open) this.disclosure.open = true;
      });
      this.mobileMedia.addEventListener('change', this.syncDisclosure);
      this.syncDisclosure();
    }
    updateDisclosureSummary() {
      const summary = this.querySelector('[data-vehicle-summary]');
      if (!summary) return;
      const selected = this.selection();
      summary.textContent = selected
        ? `${selected.vehicle.year} ${selected.vehicle.make} ${selected.vehicle.model}${selected.submodel.slug === 'all' ? '' : ' — ' + selected.submodel.name} — ${selected.drivetrain.toUpperCase()}`
        : this.dataset.summaryPlaceholder;
    }
    resultsURL(selected) {
      const url = new URL(this.dataset.search, location.origin);
      const exclusion = selected.submodel.slug === 'all' ? '' : ` AND -tag:fit-exclude-${selected.submodel.slug}`;
      const tags = [`${selected.vehicle.tag}-${selected.drivetrain}`, ...(selected.vehicle.additionalTags?.[selected.drivetrain] || [])];
      const query = tags.length === 1 ? `tag:${tags[0]}` : `(${tags.map(tag => `tag:${tag}`).join(' OR ')})`;
      url.searchParams.set('q', `${query}${exclusion}`);
      url.searchParams.set('type', 'product');
      url.searchParams.set('view', 'vehicle');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url;
    }
    fill(select, values) {
      select.replaceChildren(new Option(this.dataset.placeholder, ''));
      values.forEach(value => select.add(new Option(value.name || value, value.slug || value)));
      select.disabled = values.length === 0;
    }
    refreshMakes() {
      this.fill(this.make, [...new Set(this.vehicles.filter(v => String(v.year) === this.year.value).map(v => v.make))]);
      this.refreshModels();
    }
    refreshModels() {
      this.fill(this.model, [...new Set(this.vehicles.filter(v => String(v.year) === this.year.value && v.make === this.make.value).map(v => v.model))]);
      this.refreshSubmodels();
    }
    refreshSubmodels() {
      const vehicle = this.selected();
      this.fill(this.submodel, vehicle ? [...vehicle.submodels, {name: this.dataset.allSubmodels, slug: 'all'}] : []);
      this.refreshDrivetrains();
    }
    refreshDrivetrains() {
      const vehicle = this.selected();
      const submodel = vehicle?.submodels.find(s => s.slug === this.submodel.value);
      const drives = submodel?.drivetrains || (vehicle && this.submodel.value === 'all' ? vehicle.drivetrains : []);
      this.fill(this.drivetrain, drives.map(slug => ({name: slug.toUpperCase(), slug})));
      this.submit.disabled = true;
      this.updateDisclosureSummary();
    }
    selected() { return this.vehicles.find(v => String(v.year) === this.year.value && v.make === this.make.value && v.model === this.model.value); }
    selection() {
      const vehicle = this.selected();
      const submodel = vehicle && [...vehicle.submodels, {name: this.dataset.allSubmodels, slug: 'all'}].find(v => v.slug === this.submodel.value);
      const allowed = submodel?.drivetrains || vehicle?.drivetrains || [];
      return submodel && allowed.includes(this.drivetrain.value) ? {vehicle, submodel, drivetrain: this.drivetrain.value} : null;
    }
  });
}

